(function () {
  var cfg = window.LA;
  function $(s, r) { return (r || document).querySelector(s); }
  function icon(n) { return '<svg class="icon" aria-hidden="true"><use href="#i-' + n + '"/></svg>'; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  // Formats cents using the store's money format, e.g. "${{amount}}".
  function money(cents) {
    var amount = (cents / 100).toFixed(2);
    return (cfg.moneyFormat || '${{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }
  function sized(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function getJSON(url, opts) { return fetch(url, opts).then(function (r) { return r.json(); }); }

  /* ---------- Product cards: instant variant switching ---------- */
  function cardVariants(card) {
    if (!card._variants) card._variants = JSON.parse(card.querySelector('.variants-json').textContent);
    return card._variants;
  }
  function onPick(e) {
    if (!e.target.matches('select[data-opt]')) return;
    var card = e.target.closest('.card');
    var picks = Array.prototype.slice.call(card.querySelectorAll('select[data-opt]')).sort(function (a, b) { return (+a.getAttribute('data-opt')) - (+b.getAttribute('data-opt')); }).map(function (s) { return s.value; });
    var v = cardVariants(card).filter(function (x) { return x.options.every(function (o, i) { return o === picks[i]; }); })[0];
    var btn = card.querySelector('.add-btn');
    if (!v) { btn.disabled = true; btn.innerHTML = 'Unavailable'; return; }
    card.querySelector('.price').textContent = money(v.price);
    btn.dataset.variantId = v.id;
    btn.disabled = !v.available;
    btn.innerHTML = v.available ? icon('bag') + 'Add to Cart' : 'Sold Out';
    if (v.featured_image) {
      var img = card.querySelector('img.main');
      var src = sized(v.featured_image.src, 720);
      if (img.getAttribute('src') !== src) img.src = src;
    }
    card.classList.add('picked');
  }
  document.addEventListener('input', onPick);
  document.addEventListener('change', onPick);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.add-btn');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var card = btn.closest('.card');
    addToCart(btn.dataset.variantId, card ? card.dataset.productId : null, card ? card.dataset.handle : null).then(function () {
      btn.classList.add('added');
      btn.innerHTML = icon('check') + 'Added';
      setTimeout(function () { btn.classList.remove('added'); btn.innerHTML = icon('bag') + 'Add to Cart'; }, 1600);
    });
  });

  // Category tabs on the home page grid (filter by product tag).
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.tab[data-tag]'); if (!t) return;
    var grid = t.closest('section').querySelector('.grid');
    t.parentNode.querySelectorAll('.tab').forEach(function (x) { x.classList.toggle('active', x === t); });
    grid.querySelectorAll('.card').forEach(function (c) {
      var show = t.dataset.tag === 'all' || c.dataset.tags.split('|').indexOf(t.dataset.tag) > -1;
      c.style.display = show ? '' : 'none';
    });
  });

  /* ---------- Cart drawer ---------- */
  var drawer = $('#cartDrawer'), overlay = $('#overlay');
  function openCart() { drawer.classList.add('open'); overlay.classList.add('show'); document.body.classList.add('no-scroll'); drawer.setAttribute('aria-hidden', 'false'); }
  function closeCart() { drawer.classList.remove('open'); overlay.classList.remove('show'); document.body.classList.remove('no-scroll'); drawer.setAttribute('aria-hidden', 'true'); }

  function renderCart(cart, bump) {
    var badge = $('#cartCount');
    badge.textContent = cart.item_count;
    badge.classList.toggle('show', cart.item_count > 0);
    if (bump) { badge.classList.remove('bump'); void badge.offsetWidth; badge.classList.add('bump'); }

    var sub = cart.total_price, remaining = Math.max(0, cfg.freeShippingAt - sub);
    $('#shipMeter').innerHTML = sub >= cfg.freeShippingAt
      ? '<div class="done">' + icon('truck') + 'You unlocked free standard shipping!</div><div class="bar"><span style="width:100%"></span></div>'
      : 'You\'re <b>' + money(remaining) + '</b> away from <b>free standard shipping</b>.<div class="bar"><span style="width:' + Math.min(100, sub / cfg.freeShippingAt * 100) + '%"></span></div>';

    var items = $('#cartItems');
    items.innerHTML = !cart.items.length
      ? '<div class="cart-empty">' + icon('bag') + '<p>Your cart is empty.</p></div>'
      : cart.items.map(function (l) {
          var variant = l.variant_title && l.variant_title !== 'Default Title' ? l.variant_title : '';
          return '<div class="line" data-key="' + l.key + '" data-qty="' + l.quantity + '"><img src="' + sized(l.image, 160) + '" alt="">' +
            '<div><h4>' + esc(l.product_title) + '</h4><div class="variant">' + esc(variant) + '</div>' +
            '<div class="qty"><button data-act="dec" aria-label="Decrease quantity">&minus;</button><span>' + l.quantity + '</span><button data-act="inc" aria-label="Increase quantity">+</button></div></div>' +
            '<div class="line-right"><span class="line-price">' + money(l.final_line_price) + '</span><button class="remove" data-act="remove">Remove</button></div></div>';
        }).join('');
    $('#sumSubtotal').textContent = money(sub);
    $('#sumShipping').innerHTML = !cart.items.length ? money(0) : sub >= cfg.freeShippingAt ? '<span class="free">FREE</span> standard' : 'Standard ' + money(cfg.shippingFee);
  }

  function refresh(bump) { return getJSON(cfg.routes.cart + '.js').then(function (c) { renderCart(c, bump); return c; }); }

  function addToCart(variantId, productId, handle) {
    return getJSON(cfg.routes.cartAdd + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function () { return refresh(true); }).then(function (cart) {
      openCart();
      if (productId) scheduleUpsell(productId, handle, cart);
    });
  }

  $('#cartItems').addEventListener('click', function (e) {
    var b = e.target.closest('[data-act]'); if (!b) return;
    var line = b.closest('.line'), qty = Number(line.dataset.qty);
    var next = b.dataset.act === 'inc' ? qty + 1 : b.dataset.act === 'dec' ? qty - 1 : 0;
    getJSON(cfg.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.dataset.key, quantity: Math.max(0, next) }) })
      .then(function (c) { renderCart(c, false); });
  });

  var cartBtn = $('#cartBtn');
  if (cartBtn) cartBtn.addEventListener('click', function (e) { e.preventDefault(); refresh(false).then(openCart); });
  $('#cartClose').addEventListener('click', closeCart);
  overlay.addEventListener('click', closeCart);

  /* ---------- "Customers also bought" (Shopify product recommendations) ---------- */
  var upsell = $('#upsell'), upTimer, hideTimer, upVariant = null, upProduct = null;

  // Hand-picked pairings, used when Shopify has no recommendation yet (new stores).
  var PAIRS = {
    'moon-lamp': ['anchor-bracelet', 'anchor-necklace'],
    'anchor-bracelet': ['anchor-necklace', 'bronze-anchor-bracelet'],
    'bronze-anchor-bracelet': ['anchor-necklace', 'anchor-bracelet'],
    'anchor-necklace': ['anchor-bracelet', 'pray-hoodie'],
    'skull-longsleeve': ['problem-solved-cap', 'pray-hoodie'],
    'pray-hoodie': ['anchor-necklace', 'skull-longsleeve'],
    'mens-quarter-zip': ['anchor-bracelet', 'usa-tactical-cap'],
    'problem-solved-cap': ['horror-slogan-cap', 'skull-longsleeve'],
    'horror-slogan-cap': ['problem-solved-cap', 'skull-longsleeve'],
    'king-queen-caps': ['bronze-anchor-bracelet', 'anchor-bracelet'],
    'usa-tactical-cap': ['bronze-anchor-bracelet', 'mens-quarter-zip']
  };

  function fallbackRec(handle, inCart) {
    var list = (PAIRS[handle] || []).slice();
    function next() {
      if (!list.length) return Promise.resolve(null);
      return fetch('/products/' + list.shift() + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        return p && p.available && inCart.indexOf(p.id) === -1 ? p : next();
      }).catch(next);
    }
    return next();
  }

  function scheduleUpsell(productId, handle, cart) {
    var inCart = cart.items.map(function (i) { return i.product_id; });
    getJSON(cfg.routes.recommendations + '.json?product_id=' + productId + '&limit=6&intent=related').catch(function () { return {}; }).then(function (data) {
      var rec = (data.products || []).filter(function (p) { return inCart.indexOf(p.id) === -1 && p.available; })[0];
      return rec || fallbackRec(handle, inCart);
    }).then(function (rec) {
      if (!rec) return;
      var v = rec.variants.filter(function (x) { return x.available; })[0] || rec.variants[0];
      clearTimeout(upTimer); clearTimeout(hideTimer);
      upsell.classList.remove('show');
      upTimer = setTimeout(function () {
        upVariant = v.id; upProduct = rec.id;
        $('#upsellImg').src = sized(rec.featured_image, 160);
        $('#upsellName').textContent = rec.title;
        $('#upsellPrice').textContent = money(v.price);
        $('#upsellView').href = rec.url;
        upsell.classList.add('show');
        hideTimer = setTimeout(function () { upsell.classList.remove('show'); }, 11000);
      }, 1200);
    });
  }
  $('#upsellClose').addEventListener('click', function () { upsell.classList.remove('show'); });
  $('#upsellAdd').addEventListener('click', function () {
    if (!upVariant) return;
    upsell.classList.remove('show');
    addToCart(upVariant, null, null);
  });

  /* ---------- Mobile menu ---------- */
  var menu = $('#mobileMenu');
  function openMenu() { menu.classList.add('open'); document.body.classList.add('no-scroll'); $('#menuBtn').setAttribute('aria-expanded', 'true'); }
  function closeMenu() { menu.classList.remove('open'); document.body.classList.remove('no-scroll'); $('#menuBtn').setAttribute('aria-expanded', 'false'); }
  $('#menuBtn').addEventListener('click', openMenu);
  $('#menuClose').addEventListener('click', closeMenu);
  menu.querySelector('.scrim').addEventListener('click', closeMenu);
  menu.addEventListener('click', function (e) { if (e.target.closest('a')) closeMenu(); });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeCart(); closeMenu(); upsell.classList.remove('show');
  });

  refresh(false);
})();
